import React, {Component} from 'react';
import axios from 'axios';
import './Myprofile.css';
import Breadcrumbs from '../Components/Breadcrumbs';
class Myaccount extends React.Component {
  constructor(props) {
    super(props);

  }
 
  render() {
    
      return <div>
        
  <div className="container">
      
          <div className="row">
          <Breadcrumbs title="My profile" bc="My profile"/>
              <div className="col-md-4">
              <h2 className="">My profile</h2>
              </div>
              <div className="col-md-8 ">
                <div className="bottom-line  line-space">
                <div className="float-right"><p><a href="#"></a></p>
          </div>
              <p className="">You can manage and set your address information here</p>
              <div className="float-right inline"><img src="./assets/images/chair.png" className="product-thumbnails round-img" alt=""/></div>
      
              <h6 className="opacity-header">Full Name</h6>
        <p>Rosbin</p>
        <h6 className="opacity-header">Email Address</h6> 
        <p>Rosbin123@gmail.cpm</p>
        <h6 className="opacity-email"> Email Address Not Yet Validated</h6>
        <p className="green-link"><a href="#"><u>Resend Validatation Mail</u></a></p>
        <h6 className="opacity-header">Mobile Number</h6> 
        <p className="">12342342</p>
        </div>
      
              </div>
          </div>
          <div className="row wallet-balance">
          
                <div className="col-md-4">
                 <h2>Manage Address</h2>
  
                  </div>
              <div className="col-md-8">
              <p className="">You can manage shipping address from here</p>
              <div className="row new-box">
            
              <div className=" btn btn-outlines ouline-space border-width next-box">
                  <h6 className="home-header line-space">Home</h6><br/><br/>
                  <h6 className="name-header "> Marcus</h6><br/>
                  <h6 className="address-header">2680,31st main road,</h6><br/>
                  <h6 className="address-header">HSR layout,Banglore</h6><br/>
                  <h6 className="address-header">Karnataka</h6><br/>
                  <h6 className="address-header">560102</h6><br/> 
                 <h6  className="address-header  mt-31">Default</h6><br/>
                </div>
  
                <div className=" btn btn-outlines ouline-space border-width brdcum box-shadow next-box">
                <p className="green-link max-top-space"><a href="#" type="button"><i className="fa fa-plus center-align  " aria-hidden="true"></i></a><br/>
                <a href="#" type="button">Add New Address<br/> Details </a></p>
                
  
                </div>

                    
                  </div>
                  
                   
                    
              </div>
              
              
        
          </div>
      </div>
  </div>
  
    
    
    

}
}

export default Myaccount;

